import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { editMenuRequest, editMenuRequestError, editMenuRequestSuccess } from '../../slices/Menu/EditMenuSlice';


export const EditMenuAPI = (id,data) => {
    return async (dispatch) => {
        try {
            dispatch(editMenuRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "PUT",
                url: `${endpoints.editMenu}/${id}`,
                data: data,
            })
            return dispatch(editMenuRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(editMenuRequestError(_error));
        }
    };
};
